import styled from 'styled-components';

export const HomeContainer = styled.div`
    z-index: 1;
    top: 0px;
    width: 100vw;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    color: #D6E1EF;
`;

export const FirstText = styled.h3`
    font-family: 'Khula', sans-serif;
    font-weight: 400;
    font-size: 22px;
    max-width: 340px;
    color: #D6E1EF;
    text-align: center;
    line-height: 78px;
    @media only screen and (max-width: 768px) {
        width: 224px;
        height: 44px;
        font-family: Khula;
        font-style: normal;
        font-weight: normal;
        font-size: 22px;
        line-height: 100%;
        display: flex;
        align-items: center;
        text-align: center;
        color: #D6E1EF;
        opacity: 0.95;
        border-bottom: 30px solid transparent;
    }
`;


export const ServicesText = styled.div`
    font-family: 'Khula', sans-serif;
    font-weight: 400;
    font-size: 22px;
    max-width: 90%;
    color: #D6E1EF;
    text-align: center;
    @media only screen and (max-width: 768px) {
        width: 224px;
        height: 44px;
        font-family: Khula;
        font-style: normal;
        font-weight: normal;
        font-size: 22px;
        line-height: 100%;
        display: flex;
        align-items: center;
        text-align: center;
        color: #D6E1EF;
        opacity: 0.95;
        border-bottom: 30px solid transparent;
    }
`;


export const MainText = styled.h1`
    font-family: 'Khula', sans-serif;
    font-weight: 800;
    font-size: 75px;
    max-width: 700px;
    color: #D6E1EF;
    text-align: center;
    line-height: 75px;
    @media only screen and (max-width: 768px) {
        width: 288px;
        height: 240px;
        font-family: Khula;
        font-style: normal;
        font-weight: 800;
        font-size: 40px;
        line-height: 100%;
        display: flex;
        align-items: center;
        text-align: center;
        color: #D6E1EF;
        opacity: 0.95;
    }
`;

export const CallToAction = styled.button`
    margin: 50px 0px;
    font-family: Khula;
    font-style: normal;
    font-weight: bold;
    font-size: 22px;
    line-height: 22px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #D6E1EF;
    outline: none;
    background: linear-gradient(90.25deg, #F06500 -21.19%, #FFA05C 126.2%);
    box-shadow: -5px -6px 16px rgba(195, 200, 205, 0.04), 6px 6px 28px rgba(0, 0, 0, 0.3);
    border-radius: 16px;
    border: none;
    width: 311px;
    height: 62px;
    cursor: pointer;
    @media only screen and (max-width: 768px) {
        margin-top: 25px;
        font-family: Khula;
        font-style: normal;
        font-weight: bold;
        font-size: 22px;
        line-height: 100%;
        display: flex;
        align-items: center;
        text-align: center;
        color: #D6E1EF;
        opacity: 0.95;
    }
`;

export const CellImageUp = styled.img`
    @media only screen and (max-width: 768px) {
        display: none;
    }
    @media only screen and (min-width: 768px) {
        position: absolute;
        transform: rotate(180deg);
        transform: rotateX(180deg);
        top: -130px;
        right: 5%;
        width: 200px;
    }
    @media only screen and (min-width: 992px) {
        right: 10%;
        width: 210px;
    }
    @media only screen and (min-width: 1200px) {
        right: 15%;
        width: 220px;
    }
    @media only screen and (min-width: 1500px) {
        right: 25%;
        width: 239px;
    }
`;

export const CellImageDown = styled.img`
    transform: rotate(35deg);
    @media only screen and (max-width: 768px) {
        display: none;
    }
    @media only screen and (min-width: 768px) {
        position: absolute;
        bottom: -50px;
        left: -140px;
        width: 200px;
    }
    @media only screen and (min-width: 992px) {
        left: -140px;
        width: 210px;
    }
    @media only screen and (min-width: 1200px) {
        left: -140px;
        width: 220px;
    }
    @media only screen and (min-width: 1500px) {
        left: -140px;
        width: 239px;
    }
`;